<template>
  <ContentSettingsEditor
    :edit-type="editType"
    :code="code"
  />
</template>

<script>

import ContentSettingsEditor from '@telexpress_auth/vue-moztech/dist/components/ContentSettingsEditor.umd.min';
import '@telexpress_auth/vue-moztech/dist/components/ContentSettingsEditor.css';

export default {
  components: {
    ContentSettingsEditor
  },
  props: {
    editType: {
      type: String,
      required: true,
      default: ''
    },
    code: {
      type: String,
      required: true,
      default: ''
    }
  },
  data() {
    return {
    };
  },
  created() {
  }
};
</script>
